import {
  GetPrefCitySectionByZipCodeQuery,
  GetPrefCitySectionByZipCodeDocument,
} from "@/generated/graphql";
import { ApolloQueryResult } from "@apollo/client/core";
import { generateApolloClient } from "../apolloClientUtil";

/**
 * 郵便番号から住所を返す
 * @param customerCode カスタマーコード
 * @param chainCode チェーンコード
 * @param shopCode 店舗コード
 * @param zipCode 弓場印番号
 * @returns 郵便番号から住所を返す
 */
export async function getPrefCitySectionByZipCode(
  customerCode: string,
  chainCode: string,
  shopCode: string,
  zipCode: string
): Promise<string> {
  try {
    //graphql接続
    const apolloClient = await generateApolloClient();
    const address: ApolloQueryResult<GetPrefCitySectionByZipCodeQuery> =
      await apolloClient.query<GetPrefCitySectionByZipCodeQuery>({
        query: GetPrefCitySectionByZipCodeDocument,
        variables: {
          customer_code: customerCode,
          chain_code: chainCode,
          shop_code: shopCode,
          zip_code: zipCode,
        },
        fetchPolicy: "no-cache",
      });
    const deliveryAddress = address.data.getPrefCitySectionByZipCode?.[0];
    return deliveryAddress ? deliveryAddress : "";
  } catch (err: unknown) {
    console.error(err);

    if (err instanceof Error) {
      err.message = "住所の取得に失敗しました。";
      throw err;
    } else {
      throw new Error("住所の取得に失敗しました。（Unknown error）");
    }
  }
}
